<template lang="pug">
  <!--Setting cards -->
  v-container
    v-row(justify="center")
      v-col(cols="12" )
        v-card
          v-card-title Animation canvas
          v-card-text
            v-row( justify="center")
              v-col(cols="12")
                CanvasSVG
            v-row(justify="center")
              v-col(class="pr-4")
                v-slider(hide-details class="align-center" :min="0" :max="1" :step="0.01" :value="playerPosition" @change="updatePositions($event)")
                  template(v-slot:prepend)
                    v-btn( class="mt-0 pt-0" style="width: 60px" color="primary" @click="playTimeline()" single-line)
                      v-icon {{playBtnIcon}}
    v-row(justify="center")
      v-col(cols="12" )
        v-expansion-panels
          v-expansion-panel
            v-expansion-panel-header.title Controls
            v-expansion-panel-content
              v-row
                v-slider(label="Zoom" hide-details :min="0.5" :max="5" :step="0.01" v-model="canvasScale"
                    prepend-icon="mdi-magnify-minus-outline" append-icon="mdi-magnify-plus-outline")
              v-row
                v-slider(label="Panning" hide-details :min="-1000" :max="1000" :step="50" v-model="canvasShift" prepend-icon="mdi-arrow-expand-left" append-icon="mdi-arrow-expand-right" )
</template>
<script>
import SimulationChart from "@/components/SimulationChart/SimulationChart";
import ChartSettings from "@/components/SimulationChart/ChartSettings";
import CanvasSVG from "@/assets/svg/canvas.svg";
import { gsap } from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin.js";
gsap.registerPlugin(MotionPathPlugin);

export default {
  components: {
    SimulationChart,
    ChartSettings,
    CanvasSVG
  },
  data() {
    return {
      m2px: 8.927613941,
      timeline: undefined,
      playerPosition: 0,
      playBtnToggle: false,
      canvasScale: 2,
      canvasShift: 300
    };
  },
  computed: {
    playBtnIcon() {
      if (this.playBtnToggle) {
        return "mdi-pause";
      } else {
        return "mdi-play";
      }
    },
    simulation() {
      return this.$store.state.simulation.simulation;
    },
    simulationParams() {
      return this.$store.state.simulationParams;
    },
    settings() {
      return this.$store.state.simulationSettings.settings;
    }
  },
  watch: {
    canvasScale: "updateAnimation",
    canvasShift: "updateAnimation",
    simulation: {
      deep: true,
      handler() {
        this.updateAnimation();
      }
    }
  },
  mounted() {
    // if signals is defined, update the animation
    this.updateAnimation();
  },
  methods: {
    playTimeline() {
      this.playBtnToggle = !this.playBtnToggle;
      if (this.playBtnToggle) {
        this.timeline.progress(this.playerPosition);
        this.timeline.play();
      } else {
        this.timeline.pause();
      }
    },
    getVehicleTimeline(data) {
      var tl = gsap.timeline();
      tl.addLabel("start");
      tl.set("#car", { y: data[0].y, immediateRender: true });
      data.forEach(el => {
        tl.to("#car", {
          y: el.y,
          duration: this.$store.state.simulationParams.simulation[1],
          ease: "none"
        });
      });
      tl.addLabel("end");
      return tl;
    },
    getBicycleTimeline(data) {
      var tl = gsap.timeline();
      tl.addLabel("start");
      tl.set("#bike", { x: data[0].x, immediateRender: true });
      data.forEach(el => {
        tl.to("#bike", {
          x: el.x,
          duration: this.$store.state.simulationParams.simulation[1],
          ease: "none"
        });
      });
      tl.addLabel("end");
      return tl;
    },
    getCanvasTimeline(data) {
      var tl = gsap.timeline();
      tl.addLabel("start");
      tl.set("#animationSVG > .canvas", {
        x: this.canvasScale * data[0].y - this.canvasShift,
        immediateRender: true
      });
      data.forEach(el => {
        tl.to("#animationSVG > .canvas", {
          x: this.canvasScale * el.y - this.canvasShift,
          duration: this.$store.state.simulationParams.simulation[1],
          ease: "none"
        });
      });
      tl.addLabel("end");
      return tl;
    },
    updateAnimation() {
      const signals = this.simulation.signals;
      const tl = gsap.timeline({ paused: true });
      const floatPrecision = 10 ** 2;
      // Create paths
      var vehicleMotionPath = [];
      signals.forEach((signalEl, i) => {
        if (i !== 0) {
          vehicleMotionPath.push({
            y:
              -Math.round(signalEl.vehiclePos * this.m2px * floatPrecision) /
              floatPrecision
          });
        }
      });

      var bicycleMotionPath = [];
      signals.forEach((signalEl, i) => {
        if (i !== 0) {
          bicycleMotionPath.push({
            x:
              Math.round(signalEl.bicyclePos * this.m2px * floatPrecision) /
              floatPrecision
          });
        }
      });

      gsap.set("#animationSVG > .canvas", {
        rotate: 90,
        transformOrigin: "top ",
        y: "400",
        x: "600"
      });
      gsap.set("#animationSVG > .canvas", {
        transformOrigin: "40% center",
        scale: this.canvasScale
      });
      gsap.set("#houses", {
        x: this.simulationParams.simulation[0] * this.m2px,
        y: 1 * this.m2px
      });

      tl.add(this.getVehicleTimeline(vehicleMotionPath))
        .add(this.getBicycleTimeline(bicycleMotionPath), "<")
        .add(this.getCanvasTimeline(vehicleMotionPath), "<");
      tl.eventCallback("onUpdate", this.updatePlayerPosition);
      tl.progress(this.playerPosition);
      this.timeline = tl;
    },
    updatePlayerPosition: function() {
      this.playerPosition = this.timeline.progress();
    },
    updatePositions: function(playerPosition) {
      if (this.playBtnToggle) {
        this.timeline.pause();
        this.playerPosition = playerPosition;
        this.timeline.progress(this.playerPosition);
        this.timeline.play();
      } else {
        this.playerPosition = playerPosition;
        this.timeline.progress(this.playerPosition);
      }
    }
  }
};
</script>
<style scoped>
#animationSVG {
  max-height: 500px;
}
</style>
